<template>
  <div class="appeal-page">
    <h1>移民及难民法庭上诉</h1>

    <div class="intro">
      <p>加拿大移民上诉庭IAD (Immigration Appeal Division) 是加拿大移民及难民委员会IRB (Immigration and Refugee Board)下属的四个行政法庭中的一个法庭，该庭主要负责四种上诉的审理判决：</p>
      <ul>
        <li>担保家庭成员移民上诉</li>
        <li>收到遣返令removal order的上诉</li>
        <li>居住时间不足的上诉</li>
        <li>离境上诉</li>
      </ul>
    </div>

    <section class="sponsorship-appeal" @click="$router.push('/appeal/family')">
      <h2>担保家庭成员移民上诉</h2>
      <div class="content">
        <p>加拿大移民法规定：18岁以上的加拿大公民或永久居民可以担保家庭成员移民加拿大，这些家庭成员包括配偶 (同居伴侣或婚姻伴侣)、子女 (22岁以下未婚的亲生子女、父母或祖父母、未满18岁的孤儿)、兄弟姐妹、孕子存在于外外嫁女、或其他亲属移民加拿大 (如果没有以上亲属成员)。如果所提供的家庭成员移民加拿大的申请被拒绝，担保人可以向移民上诉出的决定有异议，则可以向IAD提出上诉。</p>
      </div>
    </section>

    <section class="residency-appeal" @click="$router.push('/appeal/residency')">
      <h2>居住时间不足上诉</h2>
      <div class="content">
        <p>加拿大移民法规定，加拿大枫叶卡的持有人（即加拿大永久居民）必须履行其居住义务（Residency Obligation）的责任。在持卡的有效期五年内在加拿大生活满两年（730天），只要达成为公民，就一定要履行义务。在加拿大，永久居民可以向移民上诉庭递交居住义务豁免申请，并可能会获得豁免。如果上诉人认为上诉的IAD...</p>
      </div>
    </section>

    <section class="removal-appeal" @click="$router.push('/appeal/deportation')">
      <h2>遣返令上诉</h2>
      <div class="content">
        <p>遣返令（Removal Order）是由加拿大移民局IRCC及加拿大边境服务署CBSA发放的一份要求当事人离开加拿大，根据个人的情况，遣返令可即刻执行，延迟执行或递交上诉。遣返令共有三种，从轻至重依次为：Departure Order离境令：30天内必须离境，出境后可时时申请入境，返回加拿大不需要ARC...</p>
      </div>
    </section>

    <section class="refugee-appeal" @click="$router.push('/appeal/refugee')">
      <h2>难民申请及难民申请被拒上诉</h2>
      <div class="content">
        <p>加拿大难民上诉庭RAD (Refugee Appeal Division) 是加拿大移民及难民委员会IRB (Immigration and Refugee Board)下属的四个行政法庭中负责难民保护的RPD (Refugee Protection Division) 拒绝难民申请的难民申请人可以向RAD提出上诉。RAD决定先作成接纳难民保护的上诉请求。</p>
      </div>
    </section>

    <section class="prra-section" @click="$router.push('/appeal/prra')">
      <h2>PRRA遣返前风险评估</h2>
      <div class="content">
        <p>PRRA就在遣返某人评估他/她回到他/她的国家所面临的任何可能的风险的最后机会。PRRA通常由被拒绝的难民申请人和被拒出境令的申请人提供出境前的新事件或证据提出。通过确保在拒绝案件后的时间里的问题老旧现状，这是防止遣返的最终保护措施。PRRA特有专业处理的执行，直到移民局做出决定，或者申请人放弃或撤回申请。PRRA申请一旦被认定，申请人将成为受保护的人（protected person）...</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AppealView'
}
</script>

<style lang="less" scoped>
.appeal-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;

  h1 {
    text-align: center;
    margin-bottom: 40px;
    color: #333;
    font-size: 32px;
    font-weight: bold;
  }

  .intro {
    background: #fff;
    padding: 30px;
    border-radius: 12px;
    margin-bottom: 40px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border: 1px solid #f0f0f0;

    p {
      margin-bottom: 20px;
      color: #333;
      line-height: 1.8;
      font-size: 16px;
    }

    ul {
      list-style: none;
      padding-left: 25px;

      li {
        margin: 12px 0;
        color: #333;
        position: relative;
        font-size: 16px;

        &:before {
          content: '•';
          position: absolute;
          left: -20px;
          color: #e63946;
          font-size: 20px;
        }
      }
    }
  }

  section {
    margin-bottom: 40px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    padding: 35px;
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
    }

    h2 {
      color: #e63946;
      margin-bottom: 25px;
      font-size: 26px;
      font-weight: bold;
      position: relative;
      padding-left: 15px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 20px;
        background: #e63946;
        border-radius: 2px;
      }
    }

    .content {
      p {
        color: #333;
        line-height: 1.8;
        margin-bottom: 20px;
        font-size: 16px;
        text-align: justify;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .appeal-page {
    padding: 20px;

    h1 {
      font-size: 28px;
      margin-bottom: 30px;
    }

    section {
      padding: 25px;

      h2 {
        font-size: 22px;
      }
    }
  }
}
</style>